import { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";

export function ExtLoginOtpPopup() {
  const [otp, setOtp] = useState(null);
  const [expiresAt, setExpiresAt] = useState(null);
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    let active = true;
    const poll = async () => {
      try {
        const { data } = await api.get("/web/otp/pending");
        if (!active) return;
        if (data && data.otp) {
          setOtp(data.otp);
          setExpiresAt(data.expires_at);
        } else {
          setOtp(null);
          setExpiresAt(null);
        }
      } catch {
        /* ignore polling errors */
      }
    };
    poll();
    const t = setInterval(poll, 3000);
    return () => {
      active = false;
      clearInterval(t);
    };
  }, []);

  useEffect(() => {
    if (!expiresAt) {
      setRemaining(0);
      return;
    }
    const tick = () => {
      const s = Math.max(0, Math.floor((new Date(expiresAt).getTime() - Date.now()) / 1000));
      setRemaining(s);
      if (s <= 0) {
        setOtp(null);
        setExpiresAt(null);
      }
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [expiresAt]);

  if (!otp || remaining <= 0) return null;

  const mm = String(Math.floor(remaining / 60)).padStart(2, "0");
  const ss = String(remaining % 60).padStart(2, "0");

  return (
    <div
      data-testid="ext-otp-popup"
      className="fixed bottom-5 right-5 z-50 w-80 rounded-2xl border border-teal-200 bg-white shadow-2xl overflow-hidden animate-in fade-in slide-in-from-bottom-4"
    >
      <div className="flex items-center gap-2 px-4 py-2.5 bg-teal-600 text-white">
        <ShieldAlert className="w-4 h-4" />
        <span className="text-sm font-semibold" data-testid="ext-otp-title">Extension login requested</span>
      </div>
      <div className="px-4 py-4 text-center">
        <div
          data-testid="ext-otp-code"
          className="text-4xl font-bold tracking-[0.35em] text-slate-900 tabular-nums"
        >
          {otp}
        </div>
        <div className="mt-2 text-xs text-slate-500">
          Expires in <span data-testid="ext-otp-countdown" className="font-semibold text-slate-700">{mm}:{ss}</span>
        </div>
        <p className="mt-3 text-[11px] leading-snug text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-2.5 py-2">
          Only enter this in your extension. Never share it.
        </p>
      </div>
    </div>
  );
}
